"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _personalDataActions = require("../actions/personalData/personalDataActions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  myData: {},
  isLoading: true,
  hasApiError: false,
  apiErrorMessage: ''
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _personalDataActions.PersonalDataActions.IS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: action.isLoadingPersonalData
      });
    case _personalDataActions.PersonalDataActions.LOAD_CURRENT_PERSONAL_DATA:
    case _personalDataActions.PersonalDataActions.SAVE_MY_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        myData: action.myData,
        isLoading: false
      });
    case _personalDataActions.PersonalDataActions.LOAD_BUSINESS_PARTNER:
      return _objectSpread(_objectSpread({}, state), {}, {
        businessPartner: action.businessPartner,
        isLoading: false
      });
    case _personalDataActions.PersonalDataActions.RESET_PASSWORD_INITIATE:
    case _personalDataActions.PersonalDataActions.RESET_PASSWORD_VALIDATE:
    case _personalDataActions.PersonalDataActions.RESET_PASSWORD_SET:
      return _objectSpread(_objectSpread({}, state), {}, {
        myData: action.myData,
        isLoading: false
      });
    case _personalDataActions.PersonalDataActions.SET_API_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        hasApiError: true,
        apiErrorMessage: action.apiErrorMessage
      });
    case _personalDataActions.PersonalDataActions.CLEAR_API_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasApiError: false,
        apiErrorMessage: ''
      });
    default:
      return state;
  }
}